import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const ActiveComponentChanged = createAction(
  '[Shared: Eliqua]: Active Component Changed',
  props<{ activeComponent: string }>(),
);

export const SetActiveTabIndex = createAction(
  '[Shared: Eliqua]: Active Index Tab',
  props<{ activeTabIndex: number }>(),
);

export const ValidateSubscription = createAction('[Shared: Eliqua]: Validate Subscription');

export const ValidateSubscriptionSuccess = createAction(
  '[Shared: Eliqua]: Validate Subscription Success',
  props<{ res: any }>(),
);

export const ValidateSubscriptionFailed = createAction(
  '[Shared: Eliqua]: Validate Subscription Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLanguage = createAction('[Shared: Eliqua]: Get Language');

export const GetLanguageSuccess = createAction(
  '[Shared: Eliqua]: Get Language Success',
  props<{ res: any }>(),
);

export const GetLanguageFailed = createAction(
  '[Shared: Eliqua]: Get Language Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ResetStateFromRouter = createAction(
  '[Shared: Eliqua]: Reset State From Router'
)
